<script>
import { mapGetters, mapMutations } from 'vuex';
import stepsMixin from '@/mixins/stepsMixin'
export default {
	mixins: [stepsMixin],
	props: ['client'],
	components: {
		SvgIcon: () => import('@/components/SvgIcon'),
	},
	data() {
		return {
			name: 'analisis_riesgo_financiero',
			form: {

				// ============
				eeffConsolidado: '',
				opinionAuditoria: '',
				nombreAuditor: '',
				calificacionAuditor: '',
				comentariosAuditor: '',
				balanceCuentasMas20: '',
				balanceCuentasEntre1020: '',
				balanceVariacionesMas20: '',
				tipoTenenciaInmuebles: '',
				capitalTotalActivos: '',
				destinoRecursosAccionistas: '',
				variacionVentas: '',
				comentariosPropiedadActivos: '',
				explicaVariacionesUAFIRDA: '',
				detalleEstructuraCostos: '',
				partidasExtraordinarias: '',
				flexibilidadFinanciera: '',
				explicarVariacionesCapitalContable: '',
				comentariosFlexibilidadFinanciera: '',
				situacionActualCliente: '',
				comentariosSituacionActualCliente: '',
				analisisLiquidez: '',
				tablaVencimientosDisponible: '',
				comentariosSobreDeuda: '',
				numeroDeBancos: '',
				existeGarantiasCreditosNoBBVA: '',
				avanceDelAno: '',
				presupuestoDelAno: '',
				proyeccionesProx2_3: '',
				comentariosAvanceDelAno: '',
				comentariosPresupuestoDelAno: '',
				comentariosProyeccionesProx2_3: '',
				comentariosExisteGarantiasCreditosNoBBVA: '',
				ratioGarantiasConcedidas: '',
			},
			eeff: null,
			eeffSelected: [],
			eeffLoading: false,
			eeffSuccess: false,
			tablaVencimientosForm: [
				{
					nombre: '',
					importe: '',
					ano: '',
					query: ''
				}
			],
			tablaVencimientos: []
		}
	},
	computed: {
		showTableList() {
			let data = this.tablaVencimientos.filter(sh => {
				return sh.nombre && sh.ano
			})
			return data
		},

		...mapGetters({
			_eeffByClient: 'arceEeff/eeffByCliente'
		})
	},
	watch: {
		'client': {
			handler(nVal) {
				this.fillForm()
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		fillForm() {
			let data = {}
			if(this.client.arce.hasOwnProperty(this.name)) {
				data = {...this.client.arce[this.name]}
			}

			if(!Object.keys(data).length) {
				this.$set(this, 'form', {
					eeffConsolidado: '',
					opinionAuditoria: '',
					nombreAuditor: '',
					calificacionAuditor: '',
					comentariosAuditor: '',
					balanceCuentasMas20: '',
					balanceCuentasEntre1020: '',
					balanceVariacionesMas20: '',
					tipoTenenciaInmuebles: '',
					capitalTotalActivos: '',
					destinoRecursosAccionistas: '',
					variacionVentas: '',
					comentariosPropiedadActivos: '',
					explicaVariacionesUAFIRDA: '',
					detalleEstructuraCostos: '',
					partidasExtraordinarias: '',
					flexibilidadFinanciera: '',
					explicarVariacionesCapitalContable: '',
					comentariosFlexibilidadFinanciera: '',
					situacionActualCliente: '',
					comentariosSituacionActualCliente: '',
					analisisLiquidez: '',
					tablaVencimientosDisponible: '',
					comentariosSobreDeuda: '',
					numeroDeBancos: '',
					existeGarantiasCreditosNoBBVA: '',
					avanceDelAno: '',
					presupuestoDelAno: '',
					proyeccionesProx2_3: '',
					comentariosAvanceDelAno: '',
					comentariosPresupuestoDelAno: '',
					comentariosProyeccionesProx2_3: '',	
				})
				this.$set(this, 'eeff', null)
				this.$set(this, 'tablaVencimientos', [
					{
						nombre: '',
						importe: '',
						ano: '',
						query: ''
					}
				])

				return 
			}
			
			
			this.$set(this, 'eeff', data.eeff || null)
			this.$set(this, 'tablaVencimientos', data.tablaVencimientos || [...this.tablaVencimientos])

			delete data['eeff']
			delete data['tablaVencimientos']
			this.$set(this, 'form', data)
		},
		getAnosList(data) {
			let list = []
			data.forEach(element => {
				if(!list.includes(element.ano)) {
					list.push(element.ano)
				}
			});
			return list
		},

		sumTotal(item, key) {
			let sum = item.reduce((a, c) => {
				let obj = {}
				obj[key] = a[key] + c[key]
				return obj
			})

			return sum[key]
		},	

		sumByName(item, names, key) {
			let items = item.filter(i => names.includes(i.nombre))
			let sum = items.reduce((a, c, index) => {
				let obj = {}
				// obj[key] = a[key] + c[key]
				// return obj
				obj[key] = a[key] + c[key]

				return obj
			})

			return sum[key]
		},
		setEeff() {
			this.eeffLoading = true
			let eeff = this._eeffByClient(this.client.id)
			if(!eeff) {
				return
			}
			setTimeout(() => {
				this.$set(this, 'eeff', {...eeff})
				this.eeffLoading = false
				this.eeffSuccess = true
				this.save()
			}, 2000)
		},
		
		calcFill() {
			let fields = Object.keys(this.form)
			console.log('ORIGINAL', fields.length)
			if(this.form.opinionAuditoria == '' || this.form.opinionAuditoria == 'No auditado') {
				// nombreAuditor: '',
				// calificacionAuditor: '',
				// comentariosAuditor: '',
				let index = fields.indexOf('nombreAuditor')
				fields.splice(index, 1)
				index = fields.indexOf('calificacionAuditor')
				fields.splice(index, 1)
				index = fields.indexOf('comentariosAuditor')
				fields.splice(index, 1)
			}
			if(this.form.avanceDelAno == 'NO') {
				// nombreAuditor: '',
				// calificacionAuditor: '',
				// comentariosAuditor: '',
				let index = fields.indexOf('comentariosAvanceDelAno')
				fields.splice(index, 1)
			}
			if(this.form.presupuestoDelAno == 'NO') {
				// nombreAuditor: '',
				// calificacionAuditor: '',
				// comentariosAuditor: '',
				let index = fields.indexOf('comentariosPresupuestoDelAno')
				fields.splice(index, 1)
			}
			if(this.form.proyeccionesProx2_3 == 'NO') {
				// nombreAuditor: '',
				// calificacionAuditor: '',
				// comentariosAuditor: '',
				let index = fields.indexOf('comentariosProyeccionesProx2_3')
				fields.splice(index, 1)
			}
			console.log('FINAL', fields.length)
			let points = 100 / fields.length

			let fill = 0
			fields.forEach(f => {
				if(this.form[f]) {
					fill += points
				}
			})

			return Math.round(fill)
		},
		
		save() {
			let vm = this
			let payload =  {
				client:  this.client,
				form: this.name,
				data: Object.assign({...this.form}, {eeff: this.eeff, tablaVencimientos: [...this.tablaVencimientos]}),
				fill: vm.calcFill()
			}
			
			vm._setDataChild(payload)
			vm.$emit('updateArce')
		},

		addNew() {
			this.tablaVencimientosForm.push(
				{
					nombre: '',
					importe: '',
					ano: '',
					query: ''
				}
			)
		},
		deleteItem(index) {
			this.tablaVencimientosForm.splice(index, 1)
		},
		showModal(id) {
			if(document.querySelectorAll(`${id}`).length > 1) {
				$(`body > ${id}`).remove()
				this.showModal(id)
			} else {
				$(id).appendTo("body").modal('show')

			}
		},

		showTablaForm() {
			this.$set(this, 'tablaVencimientosForm', [...this.tablaVencimientos.map(i => ({...i}))])
			this.showModal('#tabalVencimientosModal')
		},

		saveAllTV() {
			this.$set(this, 'tablaVencimientos', [...this.tablaVencimientosForm.map(i => ({...i}))])
			this.$notify({
				type: 'success',
				group: 'simulator',
				title: 'Success!',
				text: 'The record has been saved successfully'
			})
		},
		closeEEFF() {
			this.showSteps('stepsAnalysisFinancialRisk', 4)	
		},
		closeModal() {
			this.hiddenSteps()
			this.fillForm()
		},
		...mapMutations({
			_setDataChild: 'arceDetails/setDataChild'
		})
		// ...mapMutations({
		// 	setShareholders: 'arceDetails/setShareholders'
		// })
	},

	mounted() {
		$('#eeffModal').on('hide.bs.modal', this.closeEEFF)
		$('#formAnalysisFinancialRiskModal').on('hide.bs.modal', this.closeModal)
	},

	beforeDestroy() {
		$('#eeffModal').off('hide.bs.modal', this.closeEEFF)
		$('#formAnalysisFinancialRiskModal').off('hide.bs.modal', this.closeModal)
	}
}
</script>
<template>
	<div style="">
		<div class="text-right py-2">
			<button class="s-btn s-btn--primary" @click="() => {showModal('#formAnalysisFinancialRiskModal'), hiddenSteps()}" data-v-step="afr5">
				Editar
			</button>
		</div>
		<div class="">
			<div class="s-collapse__header" data-toggle="collapse" data-target="#c1_afr_1" aria-expanded="true" aria-controls="c1_afr_1">
				<div class="d-flex">
					<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> General</span></h6>
				</div>
			</div>
			<div id="c1_afr_1" class="collapse show" aria-labelledby="headingOne">
				<div class="d-flex flex-wrap py-2">
				
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0">Tipo de EEFF</p>
							<input class="form-control form-control--disabled" disabled type="text" value="Individuales">
						</label>
					</div>
					
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> EEFF Consolidados</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.eeffConsolidado">
						</label>
					</div>

					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0">Moneda</p>
							<input class="form-control form-control--disabled" disabled type="text" value="Pesos mexicanos">
						</label>
					</div>
					
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0">Unidades</p>
							<input class="form-control form-control--disabled" disabled type="text" value="Miles">
						</label>
					</div>
					
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0">Números de Empleados</p>
							<input class="form-control form-control--disabled" disabled type="text" value="300">
						</label>
					</div>
					
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Opinión de la auditoría</p>
							<select class="form-control form-control--disabled" disabled v-model="form.opinionAuditoria"> 
								<option value="" disabled></option>
								<option value="Auditado calificado">Auditado calificado</option>
								<option value="Auditado sin calificar">Auditado sin calificar</option>
								<option value="No auditado">No auditado</option>
							</select>
						</label>
					</div>

					<div class="col-3 py-2" v-if="form.opinionAuditoria != '' && form.opinionAuditoria != 'No auditado'">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Nombre del Auditor</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.nombreAuditor">
						</label>
					</div>
					
					<div class="col-3 py-2" v-if="form.opinionAuditoria != '' && form.opinionAuditoria != 'No auditado'">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Calificación del Auditor</p>
							<select class="form-control form-control--disabled" disabled type="text" v-model="form.calificacionAuditor">
								<option value="" disabled></option>
								<option value="A">A</option>
								<option value="B">B</option>
								<option value="C">C</option>
								<option value="D">D</option>
							</select>
						</label>
					</div>

					<div class="col-3 py-2" v-if="form.opinionAuditoria != '' && form.opinionAuditoria != 'No auditado'">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Comentarios sobre la opinión de auditoria</p>
							<input class="form-control" type="text" v-model="form.comentariosAuditor">
						</label>
					</div>

				</div>
			</div>

			<div class="s-collapse__header collapsed  mt-2" data-v-step="afr1" @click="showSteps('stepsAnalysisFinancialRisk', 1)" data-toggle="collapse" data-target="#c1_afr_2" aria-expanded="true" aria-controls="c1_afr_2">
				<div class="d-flex" >
					<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Resumen Balance General / Resumen Estado de Resultados</span></h6>
				</div>
			</div>
			<div id="c1_afr_2" class="collapse hide" aria-labelledby="headingOne">
				<div class="py-3">
					<button class="s-btn s-btn--primary" @click="() => {showModal('#eeffModal'), showSteps('stepsAnalysisFinancialRisk', 2)}" data-v-step="afr2">Buscar EEFF</button>
				</div>
				<div>
					<div class="s-collapse__header  mt-2 bg-white" data-toggle="collapse" data-target="#afrd2-balance" aria-expanded="true" aria-controls="collapseTwo">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span>  Balance General</span></h6>
						</div>
					</div>
					<div id="afrd2-balance" class="collapse show" aria-labelledby="headingOne">
						<table v-if="eeff" class="s-table w-100">
							<thead class="text-uppercase">
								<tr>
									<th class="py-1"></th>
									<th class="py-1" v-for="bg in eeff.balance_general" colspan="2">
										{{ bg.fecha }} {{ bg.estado }}
									</th>
								</tr>
								<tr>
									<th class="py-1"></th>
									<template v-for="bg in eeff.balance_general">
										<th class="py-1 text-right">Importe</th>
										<th class="py-1 text-right">Prorcentaje</th>
									</template>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="py-1">
										TOTAL ACTIVOS FIJOS
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumTotal(bg.activo_fijo, 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumTotal(bg.activo_fijo, 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Activos fijos
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumTotal(bg.activo_fijo, 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumTotal(bg.activo_fijo, 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Intangibles
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">0</td>
										<td class="py-1  text-right">0%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Activos financieros
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">0</td>
										<td class="py-1  text-right">0%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Credito mercantil
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.otros_activos, ['Credito mercantil'], 'importe') | numeral('0,0') }}</td>
										<td class="py-1  text-right">{{sumByName(bg.otros_activos, ['Credito mercantil'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Activo X Impuestos Dif. 
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.otros_activos, ['Activo por impuestos diferidos'], 'importe') | numeral('0,0') }}</td>
										<td class="py-1  text-right">{{sumByName(bg.otros_activos, ['Activo por impuestos diferidos'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										ACTIVOS CIRCULANTES 
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumTotal(bg.activo_circulante, 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumTotal(bg.activo_circulante, 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Inventarios
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Inventarios'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Inventarios'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Otras cuentas X Cobrar
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Pagos Anticipados', 'Otros Act. Circ. Operativos'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Pagos Anticipados', 'Otros Act. Circ. Operativos'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Clientes y Doctos. X Cobrar
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Clientes y doctos x cob'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Clientes y doctos x cob'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										A Cuentas Intercomapañias
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Cuentas por cobrar a filiales'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Cuentas por cobrar a filiales'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Deudores Diversos
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Deudores diversos'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Deudores diversos'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Inversiones CP
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Inversiones temporales'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Inversiones temporales'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Caja y Bancos
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Caja y Bancos'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.activo_circulante, ['Caja y Bancos'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										TOTAL ACTIVOS
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{(sumTotal(bg.activo_fijo, 'importe') + sumTotal(bg.activo_circulante, 'importe') + sumByName(bg.otros_activos, ['Activo por impuestos diferidos'], 'importe')) | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{(sumTotal(bg.activo_fijo, 'porcentaje') +  sumTotal(bg.activo_circulante, 'porcentaje') + sumByName(bg.otros_activos, ['Activo por impuestos diferidos'], 'porcentaje'))}}%</td>
									</template>
								</tr>
							</tbody>
						</table>


						<table v-if="eeff" class="s-table w-100 mt-5">
							<thead class="text-uppercase">
								<tr>
									<th class="py-1"></th>
									<th class="py-1" v-for="bg in eeff.balance_general" colspan="2">
										{{ bg.fecha }} {{ bg.estado }}
									</th>
								</tr>
								<tr>
									<th class="py-1"></th>
									<template v-for="bg in eeff.balance_general">
										<th class="py-1 text-right">Importe</th>
										<th class="py-1 text-right">Prorcentaje</th>
									</template>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="py-1">
										CAPITAL CONTABLE
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumTotal(bg.capital, 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumTotal(bg.capital, 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Capital Social
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.capital, ['Capital social actualizado'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.capital, ['Capital social actualizado'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Reservas y Utilidad Acum.
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.capital, ['Reservas', 'Utilidad retenidas'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.capital, ['Reservas', 'Utilidad retenidas'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Utilidad del Ejercicio.
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.capital, ['Itilidad del ejercicio'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.capital, ['Itilidad del ejercicio'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Otro Capital
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.capital, ['Aportaciones pendientes capital', 'Prima en emisiones de acciones', 'Interes minoritario', 'Exc(Insuf) actualización de capital', 'Impacto ISR diferido'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.capital, ['Aportaciones pendientes capital', 'Prima en emisiones de acciones', 'Interes minoritario', 'Exc(Insuf) actualización de capital', 'Impacto ISR diferido'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										PASIVOS LARGO PLAZO
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumTotal(bg.pasivos_largo_plazo, 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumTotal(bg.pasivos_largo_plazo, 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Deuda financiera LP 
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.pasivos_largo_plazo, ['Bancomer largo plazo', 'Otros banco largo plazo', 'Emisiones de deuda largo plazo', 'Primas de entiguedad', 'Pasivos diferidos', 'Pasivos x impuestos diferidos'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.pasivos_largo_plazo, ['Bancomer largo plazo', 'Otros banco largo plazo', 'Emisiones de deuda largo plazo', 'Primas de entiguedad', 'Pasivos diferidos', 'Pasivos x impuestos diferidos'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										P. Cuentas Intercomapañias
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.pasivos_largo_plazo, ['Ctas x pagar Filiales'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.pasivos_largo_plazo, ['Ctas x pagar Filiales'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Otros pasivos LP
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.pasivos_largo_plazo, ['Otros pasivos largo plazo'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.pasivos_largo_plazo, ['Otros pasivos largo plazo'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										PASIVOS CORTO PLAZO
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumTotal(bg.pasivos_corto_plazo, 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumTotal(bg.pasivos_corto_plazo, 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Deuda financiera CP 
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.pasivos_corto_plazo, ['Bancomer corto plazo', 'Otros bancos corto plazo', 'Emision deuda corto plazo', 'Porc. Circ Largo plazo bancomer', 'Porc. Circ Largo plazo otros bancos'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.pasivos_corto_plazo, ['Bancomer corto plazo', 'Otros bancos corto plazo', 'Emision deuda corto plazo', 'Porc. Circ Largo plazo bancomer', 'Porc. Circ Largo plazo otros bancos'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										P. Cuentas Intercomapañias
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.pasivos_corto_plazo, ['Cuentas por pagar filiales'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.pasivos_corto_plazo, ['Cuentas por pagar filiales'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Proveedores
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.pasivos_corto_plazo, ['Proveedores'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.pasivos_corto_plazo, ['Proveedores'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Impuestos x Pagar
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.pasivos_corto_plazo, ['Impuestos por pagar'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.pasivos_corto_plazo, ['Impuestos por pagar'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										Otros Pasivos
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{sumByName(bg.pasivos_corto_plazo, ['Gastos acumulados', 'Otros pasivos cric. operativo', 'Otros pasivos cric. no operativo'], 'importe') | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{sumByName(bg.pasivos_corto_plazo, ['Gastos acumulados', 'Otros pasivos cric. operativo', 'Otros pasivos cric. no operativo'], 'porcentaje')}}%</td>
									</template>
								</tr>
								<tr>
									<td class="py-1">
										TOTAL CAPITAL + PASIVO
									</td>
									<template v-for="bg in eeff.balance_general">
										<td class="py-1  text-right">{{(sumTotal(bg.pasivos_corto_plazo, 'importe') + sumTotal(bg.pasivos_largo_plazo, 'importe') + sumTotal(bg.capital, 'importe')) | numeral('0,0')}}</td>
										<td class="py-1  text-right">{{(sumTotal(bg.pasivos_corto_plazo, 'porcentaje') + sumTotal(bg.pasivos_largo_plazo, 'porcentaje') + sumTotal(bg.capital, 'porcentaje'))}}%</td>
									</template>
								</tr>
					
							</tbody>
						</table>

						
					</div>
					<div class="s-collapse__header  mt-2 bg-white" data-toggle="collapse" data-target="#afrd2-resultado" aria-expanded="true" aria-controls="collapseTwo">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span>  Estado de resultados</span></h6>
						</div>
					</div>
					<div id="afrd2-resultado" class="collapse show" aria-labelledby="headingOne">
						<div v-if="eeff">
							<table v-if="eeff.hasOwnProperty('estado_de_resultados')" class="s-table w-100">
								<thead>
									<tr>
										<th class="py-1"></th>
										<th class="py-1"></th>
										<th class="text-right py-1" v-for="er in eeff.estado_de_resultados">
											{{ er.fecha }} {{ er.estado }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(key, keyIndex) in eeff.estado_de_resultados[0].datos">
										<td class="py-1">{{key.simbolo}}</td>
										<td class="py-1">{{key.nombre}}</td>
										<template v-for="er in  eeff.estado_de_resultados">
											<td class="text-right py-1">
												{{er.datos[keyIndex].importe | numeral('0,0')}}
											</td>
										</template>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="s-collapse__header  mt-2 bg-white" data-toggle="collapse" data-target="#afrd2-flujocaja" aria-expanded="true" aria-controls="collapseTwo">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span>  Flujo de Caja</span></h6>
						</div>
					</div>
					<div id="afrd2-flujocaja" class="collapse show" aria-labelledby="headingOne">
						<div v-if="eeff">
							<table v-if="eeff.hasOwnProperty('flujo_de_caja')" class="s-table w-100">
								<thead>
									<tr>
										<th>

										</th>
										<th class="text-right py-1" v-for="er in eeff.flujo_de_caja">
											{{ er.fecha }} {{ er.estado }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(key, keyIndex) in eeff.flujo_de_caja[0].datos">
										<td class="py-1">{{key.nombre}}</td>
										<template v-for="er in  eeff.flujo_de_caja">
											<td class="text-right py-1">
												{{er.datos[keyIndex].importe | numeral('0,0')}}
											</td>
										</template>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="s-collapse__header  mt-2 bg-white" data-toggle="collapse" data-target="#afrd2-ratios-margenes" aria-expanded="true" aria-controls="collapseTwo">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span>  Ratios y Magnitudes</span></h6>
						</div>
					</div>
					<div id="afrd2-ratios-margenes" class="collapse show" aria-labelledby="headingOne">
						<div v-if="eeff">
							<table v-if="eeff.hasOwnProperty('ratios_y_magnitudes')" class="s-table w-100">
								<thead>
									<tr>
										<th>

										</th>
										<th class="text-right py-1" v-for="er in eeff.ratios_y_magnitudes">
											{{ er.fecha }} {{ er.estado }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(key, keyIndex) in eeff.ratios_y_magnitudes[0].datos">
										<td class="py-1">{{key.nombre}}</td>
										<template v-for="er in  eeff.ratios_y_magnitudes">
											<td class="text-right py-1">
												{{er.datos[keyIndex].importe}}
											</td>
										</template>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="d-flex flex-wrap">
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Dentro del Balance General, Identifica las cuentas que representen más del 20% del total de activos y explica  el porqué de sus variaciones.</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.balanceCuentasMas20">
						</label>
					</div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Dentro del Balance General, Identifica las cuentas que estén entre el 10% y el 20% y explica el porqué de las variaciones. considerando que no hayan sido ya entes explicadas.</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.balanceCuentasEntre1020">
						</label>
					</div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Explicar variaciones en cuentas del Balance General que presenten variaciones superiores al 20% y que no hayan sido explicadas ya.</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.balanceVariacionesMas20">
						</label>
					</div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Tipo de tenencia de Inmuebles donde se desarrolla la actividad</p>
							<select class="form-control form-control--disabled" disabled type="text" v-model="form.tipoTenenciaInmuebles">
							<option value=""></option>
							<option value="Media Rentas">Media Rentas</option>
							<option value="Inversión en Acciones">Inversión en Acciones</option>
							<option value="Inversión en Activos">Inversión en Activos</option>
							<option value="Arrendamientos">Arrendamientos</option>
							<option value="Varios">Varios</option>
							<option value="Otros">Otros</option>
							</select>
						</label>
					</div>
					<!--  -->
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Destino de los recursos de los accionistas</p>
							<select class="form-control form-control--disabled" disabled type="text" v-model="form.destinoRecursosAccionistas">
							<option value=""></option>
							<option value="No invierte en la compañia">No invierte en la compañia</option>
							<option value="Reinvierte completamente en la compañia">Reinvierte completamente en la compañia</option>
							<option value="Reinvierte parcialmente en la compañia">Reinvierte parcialmente en la compañia</option>
							</select>
						</label>
					</div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Explicar las variaciones en ventas (contemplar variaciones en volúmenes, precios, tipo de cambio y sector)</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.variacionVentas">
						</label>
					</div>
					<div class="col-3 py-2"></div>
					<div class="col-3 py-2"></div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Comentarios sobre la propiedad de los activos.</p>
							<textarea class="form-control form-control--disabled" disabled type="text" v-model="form.comentariosPropiedadActivos">
							</textarea>
						</label>
					</div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Explicar variaciones de la UAFIRDA</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.explicaVariacionesUAFIRDA">
						</label>
					</div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Detalle de la Estructura de Costos</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.detalleEstructuraCostos">
						</label>
					</div>
					<div class="col-3 py-2">
						
					</div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Flexibilidad Financiera</p>
							<select class="form-control form-control--disabled" disabled type="text" v-model="form.flexibilidadFinanciera">
								<option value=""></option>
								<option value="Buen Acceso / Bajo Requerimiento">Buen Acceso / Bajo Requerimiento</option>
								<option value="Acceso Promerdio / Bajo Requerimiento">Acceso Promerdio / Bajo Requerimiento</option>
								<option value="Buen Acceso / Requerimiento Promedio">Buen Acceso / Requerimiento Promedio</option>
								<option value="Bajo Acceso / Bajo Requerimiento">Bajo Acceso / Bajo Requerimiento</option>
								<option value="Acceso Promeidio / Requiriemiento Promedio">Acceso Promeidio / Requiriemiento Promedio</option>
								<option value="Buen Acceso / Alto Requerimiento">Buen Acceso / Alto Requerimiento</option>
								<option value="Bajo Acceso / Requerimiento promedio">Bajo Acceso / Requerimiento promedio</option>
								<option value="Acceso Promedio / Alto Requerimiento">Acceso Promedio / Alto Requerimiento</option>
								<option value="Bajo Acceso / Alto Requerimiento">Bajo Acceso / Alto Requerimiento</option>
							</select>
						</label>
					</div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Explicar las variaciones en el Capital Contable </p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.explicarVariacionesCapitalContable">
						</label>
					</div>
					<div class="col-3 py-2"></div>
					<div class="col-3 py-2"></div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Comentarios sobre la flexibilidad financiera</p>
							<textarea class="form-control form-control--disabled" disabled type="text" v-model="form.comentariosFlexibilidadFinanciera">
							</textarea>
						</label>
					</div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> ¿Cuál es la situacion actual del cliente?</p>
							<select class="form-control form-control--disabled" disabled type="text" v-model="form.situacionActualCliente">
							<option value=""></option>
							<option value="Muy Buena">Muy Buena</option>
							<option value="Buena">Buena</option>
							<option value="Normal">Normal</option>
							<option value="Mala">Mala</option>
							<option value="Muy Mala">Muy Mala</option>
							</select>
						</label>
					</div>
					<div class="col-3 py-2"></div>
					<div class="col-3 py-2"></div>
					<div class="col-3 py-2"></div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Comentario sobre la sitaución de la empresa</p>
							<textarea class="form-control form-control--disabled" disabled type="text" v-model="form.comentariosSituacionActualCliente">
							</textarea>
						</label>
					</div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Análisis de liquidez</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.analisisLiquidez">
						</label>
					</div>
				</div>
			</div>

			<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#c1_afr_3" aria-expanded="true" aria-controls="c1_afr_3">
				<div class="d-flex">
					<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Tabla de Vencimientos</span></h6>
				</div>
			</div>
			<div id="c1_afr_3" class="collapse hide" aria-labelledby="headingOne">
				<div class="d-flex flex-wrap">
					
					<div class="col-3 py-2">
						
					</div>

					<div class="col-12 py-2" v-if="form.tablaVencimientosDisponible == 'SI'">
						<div class="mb-3">
							<h3 class="text-center">Tabla Vencimientos</h3>
							<table class="s-table w-100 text-center">
								<thead>
									<tr>
										<th>NOMBRE</th>
										<th v-for="(ano, index) in getAnosList(showTableList)" :key="`tabla_vencimientos-${index}`">
											{{ano}}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(sh, index) in showTableList" :key="`tabla_vencimientos_2_${index}`">
										<td>{{sh.nombre}}</td>
										<td v-for="(ano, index) in getAnosList(showTableList)" :key="`tabla_vencimientos-${index}`">
											{{ ano == sh.ano ? sh.importe : 0 }}%
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div>
							<!-- <button type="button" @click="showTablaForm"  class="s-btn s-btn--primary s-btn--outline" >Administrar Tabla de Vencimientos</button> -->
						</div>
					</div>

					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Comentario sobre la sitaución de la empresa</p>
							<textarea class="form-control form-control--disabled" disabled type="text" v-model="form.comentariosSobreDeuda">
							</textarea>
						</label>
					</div>
					<div class="col-3 py-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Número de Bancos</p>
							<select class="form-control form-control--disabled" disabled type="text" v-model="form.numeroDeBancos">
								<option value=""></option>
								<option value="Trabaja con 4 o menos bancos">Trabaja con 4 o menos bancos</option>
								<option value="Trabaja con 5 a 10 banco">Trabaja con 5 a 10 banco</option>
								<option value="Trabaja con más de 10 Bancos">Trabaja con más de 10 Bancos</option>
							</select>
						</label>
					</div>
					
				</div>
			</div>

			<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#c1_afr_4" aria-expanded="true" aria-controls="c1_afr_4">
				<div class="d-flex">
					<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Fuera de Balance</span></h6>
				</div>
			</div>
			<div id="c1_afr_4" class="collapse hide" aria-labelledby="headingOne">
				<div class="d-flex flex-wrap">
					<div class="col-3 py-2">
						
					</div>
				</div>
			</div>
			
			<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#c1_afr_5" aria-expanded="true" aria-controls="c1_afr_4\">
				<div class="d-flex">
					<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Proyección</span></h6>
				</div>
			</div>
			<div id="c1_afr_5" class="collapse hide" aria-labelledby="headingOne">
				<div class="d-flex flex-wrap">
					<div class="col-3 py-2">
						
						<div v-if="form.avanceDelAno == 'SI'" class="py-2">
							<label class="d-block m-0">
								<p class="m-0"><span class="text-danger">*</span> Comentarios sobre avance del año</p>
								<textarea class="form-control form-control--disabled" disabled type="text" v-model="form.comentariosAvanceDelAno">
								</textarea>
							</label>
						</div>
					</div>
					<div class="col-3 py-2">
						
						<div v-if="form.presupuestoDelAno == 'SI'" class="py-2">
							<label class="d-block m-0">
								<p class="m-0"><span class="text-danger">*</span> Presupuesto del año</p>
								<textarea class="form-control form-control--disabled" disabled type="text" v-model="form.comentariosPresupuestoDelAno">
								</textarea>
							</label>
						</div>
					</div>
					<div class="col-3 py-2">
						
						<div v-if="form.proyeccionesProx2_3 == 'SI'" class="py-2">
							<label class="d-block m-0">
								<p class="m-0"><span class="text-danger">*</span> Presupuesto del año</p>
								<textarea class="form-control form-control--disabled" disabled type="text" v-model="form.comentariosProyeccionesProx2_3">
								</textarea>
							</label>
						</div>
					</div>
				</div>
			</div>
			
		</div>

		<!-- ============================================ -->
		<!-- ============================================ -->
		<!-- ============================================ -->
		<!-- ============================================ -->
		<!-- ============================================ -->
		<div class="modal s-modal fade" style="font-size: 0.8em" id="formAnalysisFinancialRiskModal" tabindex="-1" role="dialog" aria-labelledby="formAnalysisFinancialRiskModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-xl " role="document">
				<div class="modal-content">
				<div class="modal-header p-0">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="s-collapse__header" data-toggle="collapse" data-target="#c_afr_1" aria-expanded="true" aria-controls="c_afr_1">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> General</span></h6>
						</div>
					</div>
					<div id="c_afr_1" class="collapse show" aria-labelledby="headingOne">
						<div class="d-flex flex-wrap py-2">
						
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0">Tipo de EEFF</p>
									<input class="form-control form-control--disabled" disabled type="text" value="Individuales">
								</label>
							</div>
							
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> EEFF Consolidados</p>
									<input class="form-control" type="text" v-model="form.eeffConsolidado">
								</label>
							</div>

							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0">Moneda</p>
									<input class="form-control form-control--disabled" disabled type="text" value="Pesos mexicanos">
								</label>
							</div>
							
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0">Unidades</p>
									<input class="form-control form-control--disabled" disabled type="text" value="Miles">
								</label>
							</div>
							
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0">Números de Empleados</p>
									<input class="form-control form-control--disabled" disabled type="text" value="300">
								</label>
							</div>
							
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Opinión de la auditoría</p>
									<select class="form-control" v-model="form.opinionAuditoria"> 
										<option value="" disabled></option>
										<option value="Auditado calificado">Auditado calificado</option>
										<option value="Auditado sin calificar">Auditado sin calificar</option>
										<option value="No auditado">No auditado</option>
									</select>
								</label>
							</div>

							<div class="col-3 py-2" v-if="form.opinionAuditoria != '' && form.opinionAuditoria != 'No auditado'">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Nombre del Auditor</p>
									<input class="form-control" type="text" v-model="form.nombreAuditor">
									<characters-available :max="30" :text="form.nombreAuditor"></characters-available>
									
								</label>
							</div>
							
							<div class="col-3 py-2" v-if="form.opinionAuditoria != '' && form.opinionAuditoria != 'No auditado'">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Calificación del Auditor</p>
									<select class="form-control" type="text" v-model="form.calificacionAuditor">
										<option value="" disabled></option>
										<option value="A">A</option>
										<option value="B">B</option>
										<option value="C">C</option>
										<option value="D">D</option>
									</select>
								</label>
							</div>

							<div class="col-3 py-2" v-if="form.opinionAuditoria != '' && form.opinionAuditoria != 'No auditado'">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentarios sobre la opinión de auditoria</p>
									<textarea class="form-control" type="text" v-model="form.comentariosAuditor">
									</textarea>
									<characters-available :max="500" :text="form.comentariosAuditor"></characters-available>

								</label>
							</div>

						</div>
					</div>

					<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#c_afr_2" aria-expanded="true" aria-controls="c_afr_2">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Resumen Balance General / Resumen Estado de Resultados</span></h6>
						</div>
					</div>
					<div id="c_afr_2" class="collapse hide" aria-labelledby="headingOne">
						<div class="py-3">
							<button class="s-btn s-btn--primary" @click="() => {showModal('#eeffModal'), showSteps('stepsAnalysisFinancialRisk', 2)}" data-v-step="afr2">Buscar EEFF</button>
						</div>
						<div>
							<div class="s-collapse__header  mt-2 bg-white" data-toggle="collapse" data-target="#afrd2-resultado" aria-expanded="true" aria-controls="collapseTwo">
								<div class="d-flex">
									<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span>  Estado de resultados</span></h6>
								</div>
							</div>
							<div id="afrd2-resultado" class="collapse show" aria-labelledby="headingOne">
								<div v-if="eeff">
									<table v-if="eeff.hasOwnProperty('estado_de_resultados')" class="s-table w-100">
										<thead>
											<tr>
												<th class="py-1"></th>
												<th class="py-1"></th>
												<th class="text-right py-1" v-for="er in eeff.estado_de_resultados">
													{{ er.fecha }} {{ er.estado }}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(key, keyIndex) in eeff.estado_de_resultados[0].datos">
												<td class="py-1">{{key.simbolo}}</td>
												<td class="py-1">{{key.nombre}}</td>
												<template v-for="er in  eeff.estado_de_resultados">
													<td class="text-right py-1">
														{{er.datos[keyIndex].importe | numeral('0,0')}}
													</td>
												</template>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="s-collapse__header  mt-2 bg-white" data-toggle="collapse" data-target="#afrd2-flujocaja" aria-expanded="true" aria-controls="collapseTwo">
								<div class="d-flex">
									<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span>  Flujo de Caja</span></h6>
								</div>
							</div>
							<div id="afrd2-flujocaja" class="collapse show" aria-labelledby="headingOne">
								<div v-if="eeff">
									<table v-if="eeff.hasOwnProperty('flujo_de_caja')" class="s-table w-100">
										<thead>
											<tr>
												<th>

												</th>
												<th class="text-right py-1" v-for="er in eeff.flujo_de_caja">
													{{ er.fecha }} {{ er.estado }}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(key, keyIndex) in eeff.flujo_de_caja[0].datos">
												<td class="py-1">{{key.nombre}}</td>
												<template v-for="er in  eeff.flujo_de_caja">
													<td class="text-right py-1">
														{{er.datos[keyIndex].importe | numeral('0,0')}}
													</td>
												</template>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="s-collapse__header  mt-2 bg-white" data-toggle="collapse" data-target="#afrd2-ratios-margenes" aria-expanded="true" aria-controls="collapseTwo">
								<div class="d-flex">
									<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span>  Ratios y Magnitudes</span></h6>
								</div>
							</div>
							<div id="afrd2-ratios-margenes" class="collapse show" aria-labelledby="headingOne">
								<div v-if="eeff">
									<table v-if="eeff.hasOwnProperty('ratios_y_magnitudes')" class="s-table w-100">
										<thead>
											<tr>
												<th>

												</th>
												<th class="text-right py-1" v-for="er in eeff.ratios_y_magnitudes">
													{{ er.fecha }} {{ er.estado }}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(key, keyIndex) in eeff.ratios_y_magnitudes[0].datos">
												<td class="py-1">{{key.nombre}}</td>
												<template v-for="er in  eeff.ratios_y_magnitudes">
													<td class="text-right py-1">
														{{er.datos[keyIndex].importe}}
													</td>
												</template>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div class="d-flex flex-wrap">
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Dentro del Balance General, Identifica las cuentas que representen más del 20% del total de activos y explica  el porqué de sus variaciones.</p>
									<textarea class="form-control" type="text" rows="4" v-model="form.balanceCuentasMas20"></textarea>
									<characters-available :max="1000" :text="form.balanceCuentasMas20"></characters-available>

								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Dentro del Balance General, Identifica las cuentas que estén entre el 10% y el 20% y explica el porqué de las variaciones. considerando que no hayan sido ya entes explicadas.</p>
									<textarea class="form-control" type="text" rows="4" v-model="form.balanceCuentasEntre1020"></textarea>
									<characters-available :max="1000" :text="form.balanceCuentasEntre1020"></characters-available>

								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Explicar variaciones en cuentas del Balance General que presenten variaciones superiores al 20% y que no hayan sido explicadas ya.</p>
									<textarea class="form-control" type="text" rows="4" v-model="form.balanceVariacionesMas20"></textarea>
									<characters-available :max="500" :text="form.balanceVariacionesMas20"></characters-available>

								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Tipo de tenencia de Inmuebles donde se desarrolla la actividad</p>
									<select class="form-control" type="text" v-model="form.tipoTenenciaInmuebles">
									<option value=""></option>
									<option value="Media Rentas">Media Rentas</option>
									<option value="Inversión en Acciones">Inversión en Acciones</option>
									<option value="Inversión en Activos">Inversión en Activos</option>
									<option value="Arrendamientos">Arrendamientos</option>
									<option value="Varios">Varios</option>
									<option value="Otros">Otros</option>
									</select>
								</label>
							</div>
							<div class="col-3 p-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> Capital / Total Activos < 20%</p>
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="afr_cta" value="SI" v-model="form.capitalTotalActivos">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item" >
											<input type="radio" name="afr_cta" value="NO" v-model="form.capitalTotalActivos">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Destino de los recursos de los accionistas</p>
									<select class="form-control" type="text" v-model="form.destinoRecursosAccionistas">
									<option value=""></option>
									<option value="No invierte en la compañia">No invierte en la compañia</option>
									<option value="Reinvierte completamente en la compañia">Reinvierte completamente en la compañia</option>
									<option value="Reinvierte parcialmente en la compañia">Reinvierte parcialmente en la compañia</option>
									</select>
								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Explicar las variaciones en ventas (contemplar variaciones en volúmenes, precios, tipo de cambio y sector)</p>
									<textarea class="form-control" type="text" rows="4" v-model="form.variacionVentas"></textarea>
									<characters-available :max="1000" :text="form.variacionVentas"></characters-available>
								</label>
							</div>
							<div class="col-3 py-2"></div>
							<div class="col-3 py-2"></div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentarios sobre la propiedad de los activos.</p>
									<textarea class="form-control" type="text" v-model="form.comentariosPropiedadActivos">
									</textarea>
									<characters-available :max="500" :text="form.comentariosPropiedadActivos"></characters-available>

								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Explicar variaciones de la UAFIRDA</p>
									<textarea class="form-control" type="text" rows="4" v-model="form.explicaVariacionesUAFIRDA"></textarea>
									<characters-available :max="750" :text="form.explicaVariacionesUAFIRDA"></characters-available>

								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Detalle de la Estructura de Costos</p>
									<input class="form-control" type="text" v-model="form.detalleEstructuraCostos">
									<characters-available :max="750" :text="form.detalleEstructuraCostos"></characters-available>

								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> Partida Extraordinarias</p>
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="afr_pe" value="SI" v-model="form.partidasExtraordinarias">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item" >
											<input type="radio" name="afr_pe" value="NO" v-model="form.partidasExtraordinarias">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Flexibilidad Financiera</p>
									<select class="form-control" type="text" v-model="form.flexibilidadFinanciera">
										<option value=""></option>
										<option value="Buen Acceso / Bajo Requerimiento">Buen Acceso / Bajo Requerimiento</option>
										<option value="Acceso Promerdio / Bajo Requerimiento">Acceso Promerdio / Bajo Requerimiento</option>
										<option value="Buen Acceso / Requerimiento Promedio">Buen Acceso / Requerimiento Promedio</option>
										<option value="Bajo Acceso / Bajo Requerimiento">Bajo Acceso / Bajo Requerimiento</option>
										<option value="Acceso Promeidio / Requiriemiento Promedio">Acceso Promeidio / Requiriemiento Promedio</option>
										<option value="Buen Acceso / Alto Requerimiento">Buen Acceso / Alto Requerimiento</option>
										<option value="Bajo Acceso / Requerimiento promedio">Bajo Acceso / Requerimiento promedio</option>
										<option value="Acceso Promedio / Alto Requerimiento">Acceso Promedio / Alto Requerimiento</option>
										<option value="Bajo Acceso / Alto Requerimiento">Bajo Acceso / Alto Requerimiento</option>
									</select>
								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Explicar las variaciones en el Capital Contable </p>
									<input class="form-control" type="text" v-model="form.explicarVariacionesCapitalContable">
									<characters-available :max="500" :text="form.explicarVariacionesCapitalContable"></characters-available>

								</label>
							</div>
							<div class="col-3 py-2"></div>
							<div class="col-3 py-2"></div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentarios sobre la flexibilidad financiera</p>
									<textarea class="form-control" type="text" v-model="form.comentariosFlexibilidadFinanciera">
									</textarea>
									<characters-available :max="255" :text="form.comentariosFlexibilidadFinanciera"></characters-available>

								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> ¿Cuál es la situacion actual del cliente?</p>
									<select class="form-control" type="text" v-model="form.situacionActualCliente">
									<option value=""></option>
									<option value="Muy Buena">Muy Buena</option>
									<option value="Buena">Buena</option>
									<option value="Normal">Normal</option>
									<option value="Mala">Mala</option>
									<option value="Muy Mala">Muy Mala</option>
									</select>
								</label>
							</div>
							<div class="col-3 py-2"></div>
							<div class="col-3 py-2"></div>
							<div class="col-3 py-2"></div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentario sobre la sitaución de la empresa</p>
									<textarea class="form-control" type="text" v-model="form.comentariosSituacionActualCliente">
									</textarea>
									<characters-available :max="200" :text="form.comentariosFlexibilidadFinanciera"></characters-available>
								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Análisis de liquidez</p>
									<input class="form-control" type="text" v-model="form.analisisLiquidez">
								</label>
							</div>
						</div>
					</div>

					<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#c_afr_3" aria-expanded="true" aria-controls="c_afr_3">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Tabla de Vencimientos</span></h6>
						</div>
					</div>

					<div id="c_afr_3" class="collapse hide" aria-labelledby="headingOne">
						<div class="d-flex flex-wrap">
							
							<div class="col-3 py-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> ¿La tabla de Vencimiento está disponible?</p>
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="afr_tvd" value="SI" v-model="form.tablaVencimientosDisponible">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item" >
											<input type="radio" name="afr_tvd" value="NO" v-model="form.tablaVencimientosDisponible">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</label>
							</div>

							<div class="col-12 py-2" v-if="form.tablaVencimientosDisponible == 'SI'">
								<div class="mb-3">
									<h3 class="text-center">Tabla Vencimientos</h3>
									<table class="s-table w-100 text-center">
										<thead>
											<tr>
												<th>NOMBRE</th>
												<th v-for="(ano, index) in getAnosList(showTableList)" :key="`tabla_vencimientos-${index}`">
													{{ano}}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(sh, index) in showTableList" :key="`tabla_vencimientos_2_${index}`">
												<td>{{sh.nombre}}</td>
												<td v-for="(ano, index) in getAnosList(showTableList)" :key="`tabla_vencimientos-${index}`">
													{{ ano == sh.ano ? sh.importe : 0 }}%
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div>
									<button type="button" @click="showTablaForm"  class="s-btn s-btn--primary s-btn--outline" >Administrar Tabla de Vencimientos</button>
								</div>
							</div>

							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentario sobre la Deuda</p>
									<textarea class="form-control" type="text" v-model="form.comentariosSobreDeuda">
									</textarea>
									<characters-available :max="1000" :text="form.comentariosSobreDeuda"></characters-available>

								</label>
							</div>
							<div class="col-3 py-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Número de Bancos</p>
									<select class="form-control" type="text" v-model="form.numeroDeBancos">
										<option value=""></option>
										<option value="Trabaja con 4 o menos bancos">Trabaja con 4 o menos bancos</option>
										<option value="Trabaja con 5 a 10 banco">Trabaja con 5 a 10 banco</option>
										<option value="Trabaja con más de 10 Bancos">Trabaja con más de 10 Bancos</option>
									</select>
								</label>
							</div>
							
						</div>
					</div>
					<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#c_afr_4" aria-expanded="true" aria-controls="c_afr_4">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Fuera de Balance</span></h6>
						</div>
					</div>
					<div id="c_afr_4" class="collapse hide" aria-labelledby="headingOne">
						<p>Se entiende por Riesgos fura de balance aquellos reflejados o conocidos: avales prestados, derivados, contingencias, judicial, etc.</p>
						<div class="d-flex flex-wrap">
							<div class="col-3 py-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> ¿Esta entidad avala otros créditos de otras empresas?</p>
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="afr_egcnbbva" value="SI" v-model="form.existeGarantiasCreditosNoBBVA">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item" >
											<input type="radio" name="afr_egcnbbva" value="NO" v-model="form.existeGarantiasCreditosNoBBVA">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</label>
							</div>

							<div class="col-3 py-2" v-if="form.existeGarantiasCreditosNoBBVA == 'SI'">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentarios (Detalla tipos, importes de los créditos, vencimineto de los créditos, tasas, etc) sobre garantías otorgadas</p>
									<textarea class="form-control" type="text" v-model="form.comentariosExisteGarantiasCreditosNoBBVA">
									</textarea>
									<characters-available :max="1000" :text="form.comentariosSobreDeuda"></characters-available>

								</label>
							</div>

							<div class="col-3 py-2" v-if="form.existeGarantiasCreditosNoBBVA == 'SI'">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Ratio de Garantías concedidas / Backlog</p>
									<select class="form-control" type="text" v-model="form.ratioGarantiasConcedidas">
										<option value=""></option>
										<option value="Trabaja con 4 o menos bancos">0-15%</option>
										<option value="Trabaja con 5 a 10 banco">15%-40%</option>
										<option value="Trabaja con más de 10 Bancos">40%-100%</option>
									</select>
								</label>
							</div>
						</div>
					</div>
					<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#c_afr_5" aria-expanded="true" aria-controls="c_afr_5">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Proyección</span></h6>
						</div>
					</div>
					<div id="c_afr_5" class="collapse hide" aria-labelledby="headingOne">
						<div class="d-flex flex-wrap">
							<div class="col-3 py-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> Avance del año</p>
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="afr_aa" value="SI" v-model="form.avanceDelAno">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item" >
											<input type="radio" name="afr_aa" value="NO" v-model="form.avanceDelAno">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</label>
								<div v-if="form.avanceDelAno == 'SI'" class="py-2">
									<label class="d-block m-0">
										<p class="m-0"><span class="text-danger">*</span> Comentarios sobre avance del año</p>
										<textarea class="form-control" type="text" v-model="form.comentariosAvanceDelAno">
										</textarea>
										<characters-available :max="500" :text="form.comentariosAvanceDelAno"></characters-available>
									</label>
								</div>
							</div>
							<div class="col-3 py-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> Presupuesto del año</p>
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="afr_pa" value="SI" v-model="form.presupuestoDelAno">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item" >
											<input type="radio" name="afr_pa" value="NO" v-model="form.presupuestoDelAno">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</label>
								<div v-if="form.presupuestoDelAno == 'SI'" class="py-2">
									<label class="d-block m-0">
										<p class="m-0"><span class="text-danger">*</span> Presupuesto del año</p>
										<textarea class="form-control" type="text" v-model="form.comentariosPresupuestoDelAno">
										</textarea>
									</label>
								</div>
							</div>
							<div class="col-3 py-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> Proyecciones (próximos 2-3 años)</p>
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="afr_pp23" value="SI" v-model="form.proyeccionesProx2_3">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item" >
											<input type="radio" name="afr_pp23" value="NO" v-model="form.proyeccionesProx2_3">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</label>
								<div v-if="form.proyeccionesProx2_3 == 'SI'" class="py-2">
									<label class="d-block m-0">
										<p class="m-0"><span class="text-danger">*</span> Proyecciones</p>
										<textarea class="form-control" type="text" v-model="form.comentariosProyeccionesProx2_3">
										</textarea>
									</label>
								</div>
							</div>
						</div>
					</div>
					
				</div>
				<div class="modal-footer">
					<button type="button" class="s-btn s-btn--outline" data-dismiss="modal">Cancelar</button>
					<button type="button" class="s-btn s-btn--primary" data-dismiss="modal" @click="save">Guardar</button>
				</div>
				</div>
			</div>
		</div>
		<!--  -->
		<div class="modal s-modal fade" id="eeffModal" tabindex="-1" role="dialog" aria-labelledby="eeffModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title w-100 text-center" id="eeffModalLabel">EEFF</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<table class="s-table w-100" data-v-step="afr3">
						<thead>
							<tr>
								<th></th>
								<th><input type="checkbox"></th>
								<th>Periodo</th>
								<th>Fecha</th>
								<th>Certificado</th>
								<th>Tipo</th>
								<th>Valido</th>
								<th>Tipo</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									1
								</td>
								<td>
									<input type="checkbox" v-model="eeffSelected" value="1" :disabled="eeffSelected.length >= 3 && !eeffSelected.includes('1')">
								</td>
								<td>
									12
								</td>
								<td>
									2018-12-10
								</td>
								<td>
									OF MANA...
								</td>
								<td>
									Individual
								</td>
								<td>
									Valid
								</td>
								<td>
									Non adju..
								</td>
							</tr>
							<tr>
								<td>
									1
								</td>
								<td>
									<input type="checkbox" v-model="eeffSelected" value="2" :disabled="eeffSelected.length >= 3 && !eeffSelected.includes('2')">
								</td>
								<td>
									12
								</td>
								<td>
									2018-12-10
								</td>
								<td>
									OF MANA...
								</td>
								<td>
									Individual
								</td>
								<td>
									Valid
								</td>
								<td>
									Non adju..
								</td>
							</tr>
							<tr>
								<td>
									1
								</td>
								<td>
									<input type="checkbox" v-model="eeffSelected" value="3" :disabled="eeffSelected.length >= 3 && !eeffSelected.includes('3')">
								</td>
								<td>
									12
								</td>
								<td>
									2018-12-10
								</td>
								<td>
									OF MANA...
								</td>
								<td>
									Individual
								</td>
								<td>
									Valid
								</td>
								<td>
									Non adju..
								</td>
							</tr>
							<tr>
								<td>
									1
								</td>
								<td>
									<input type="checkbox" v-model="eeffSelected" value="4" :disabled="eeffSelected.length >= 3 && !eeffSelected.includes('4')">
								</td>
								<td>
									12
								</td>
								<td>
									2018-12-10
								</td>
								<td>
									OF MANA...
								</td>
								<td>
									Individual
								</td>
								<td>
									No valid
								</td>
								<td>
									Non adju..
								</td>
							</tr>
							<tr>
								<td>
									1
								</td>
								<td>
									<input type="checkbox" v-model="eeffSelected" value="5" :disabled="eeffSelected.length >= 3 && !eeffSelected.includes('5')">
								</td>
								<td>
									12
								</td>
								<td>
									2018-12-10
								</td>
								<td>
									OF MANA...
								</td>
								<td>
									Individual
								</td>
								<td>
									No valid
								</td>
								<td>
									Non adju..
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer justify-content-start">
					<button type="button" @click="setEeff" class="s-btn s-btn--primary s-btn--outline" :disabled="eeffSelected.length < 1" data-v-step="afr4">Agregar Estados</button>
					<div class="col-12 text-center" v-if="eeffSuccess">
						<div class="text-success" style="font-size: 3em">
							<svg-icon name="check "></svg-icon>
						</div>
						<h5>Tablas actualizadas, puede cerrar la ventana.</h5>
					</div>
				</div>
				<div v-if="eeffLoading" class="s-modal__loader">
					<img class="m-auto gray" src="@/assets/simulator/loader.gif" alt="">
				</div>
				</div>
			</div>
		</div>

		<!-- ==================== -->
		<!-- ==================== -->
		<!-- ==================== -->
		<div class="modal s-modal fade" id="tabalVencimientosModal" tabindex="-1" role="dialog" aria-labelledby="tabalVencimientosModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title w-100 text-center" id="tabalVencimientosModalLabel">Administrar Tabla de Vencimientos</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="d-flex" v-for="(tv, index) in tablaVencimientosForm" :key="`tv_${index}`">
						<div class="col-4 mt-auto">
							<p class="m-0"> 
								Nombre
							</p>
							<div class="position-relative">
								<div class="position-relative">
									<div class="s-input" data-v-step="cs1">
										<input v-if="!tv.nombre" class="form-control w-100" type="text" v-model="tv.query">
										<input v-else class="form-control w-100" disabled type="text" v-model="tv.nombre">
										<svg-icon class="mx-2" name="search" />
										<span class="m-0" @click="tv.nombre = ''" v-if="tv.nombre">
											<svg-icon class="mx-2 s-input__delete" name="close" />
										</span>
									</div>
									
								</div>
								<div v-if="tv.query" class="s-query-result">
									<div class="d-flex" @click="tv.nombre = tv.query, tv.query = ''">
										<button class="s-query-btn my-auto">
											<svg-icon name="add" />
										</button>
										<div class="ml-2 my-auto">
											<p class="small m-0">Create new arce...</p>
											<p class="m-0 small">{{tv.query}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					
						<div class="col-4 mt-auto">
							<p class="m-0"> 
								Año
							</p>
							<input class="form-control w-100" type="text" v-model="tv.ano">
						</div>
						<div class="col-3 mt-auto">
							<p class="m-0"> 
								Importe
							</p>
							<input class="form-control w-100" type="text" v-model="tv.importe">
						</div>
						<div class="col-1 mt-auto">
							<button v-if="tablaVencimientosForm.length > 1" @click="deleteItem(index)" class="s-btn s-btn--transparent">
								<svg-icon name="delete" />
							</button>
						</div>
					</div>
					<div class="text-right">
						<button @click="addNew" class="s-query-btn my-auto mr-5">
							<svg-icon name="add" />
						</button>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" @click="saveAllTV" class="s-btn s-btn--primary">Save all</button>
				</div>
				</div>
			</div>
		</div>

	</div>
</template>
